import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.Text,
  title: 'Text',
  category: ComponentCategory.General,
};
